import React from "react";

export const AuthSpiralIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_18_1737)">
        <path
          d="M13 4.875C8.51269 4.875 4.875 8.51269 4.875 13C4.875 17.4873 8.51269 21.125 13 21.125C17.4873 21.125 21.125 17.4873 21.125 13C21.125 8.51269 17.4873 4.875 13 4.875Z"
          stroke="white"
          strokeDasharray="2.07 2.07"
        />
        <path
          opacity="0.4"
          d="M13 25.1875C19.731 25.1875 25.1875 19.731 25.1875 13C25.1875 6.26903 19.731 0.8125 13 0.8125C6.26903 0.8125 0.8125 6.26903 0.8125 13C0.8125 19.731 6.26903 25.1875 13 25.1875Z"
          stroke="white"
          strokeDasharray="2.07 2.07"
        />
        <path
          d="M13 17.0625C15.2437 17.0625 17.0625 15.2437 17.0625 13C17.0625 10.7563 15.2437 8.9375 13 8.9375C10.7563 8.9375 8.9375 10.7563 8.9375 13C8.9375 15.2437 10.7563 17.0625 13 17.0625Z"
          fill="url(#paint0_linear_18_1737)"
          fillOpacity="0.8"
          stroke="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_18_1737"
          x1="12.7246"
          y1="11.8051"
          x2="13.9594"
          y2="17.213"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0352858" stopColor="#0088B2" />
          <stop offset="1" stopColor="#FFCC00" />
        </linearGradient>
        <clipPath id="clip0_18_1737">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
